module.exports = __webpack_public_path__ + "img/octopus.967748e1.jpg";